<template>
  <div class="user-profile-card meeting-card" v-if="name">
    <div class="profile-avatar">
      <k-avatar v-if="avatarUrl" :avatarUrl="avatarUrl"></k-avatar>
      <div v-else class="avatar-circle">
        <i class="fas fa-user" aria-hidden="true"></i>
      </div>
    </div>
    <div class="profile-info">
      <h3 class="profile-name">{{ name }}</h3>
      <div class="profile-role" v-if="formattedUserRole">
        <span class="capitalize-text">{{ formattedUserRole }}</span>
      </div>
      <div
        v-for="(detail, index) in details"
        :key="`${detail.label || 'detail'}-${index}`"
        class="profile-detail"
      >
        <span v-if="detail.label" class="profile-detail-label">{{ detail.label }}:</span>
        <span>{{ detail.value }}</span>
      </div>
      <div class="profile-email" v-if="email">
        <span>{{ email }}</span>
      </div>
    </div>
    <slot></slot>
  </div>
  <div v-else class="user-profile-card meeting-card">
    <div class="profile-avatar">
      <div class="avatar-circle">
        <i class="fas fa-user" aria-hidden="true"></i>
      </div>
    </div>
    <div class="profile-info">
      <span class="profile-role">No user selected</span>
    </div>
  </div>
</template>

<style>
.signed-success {
  color: var(--kate-type-success);
}

.signed-pending {
  color: var(--kate-type-danger);
}
</style>

<style scoped>
.user-profile-card {
  align-items: center;
  display: flex;
  gap: 15px;
  padding: 15px;
  border-radius: 15px;
  background-color: var(--kate-panel-alt);
  border: 1px solid var(--kate-stroke-dark);
  margin: 20px 0;
}

.profile-avatar {
  flex-shrink: 0;
}

.avatar-circle {
  width: 64px;
  height: 64px;
  border-radius: 50%;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  display: flex;
  align-items: center;
  justify-content: center;
}

.avatar-circle i {
  color: var(--kate-mono-1);
}

.capitalize-text {
  text-transform: capitalize;
}

.profile-info {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.profile-name {
  margin: 0;
  font-size: 1.25em;
  line-height: 1.2;
}

.profile-role,
.profile-email {
  display: flex;
  align-items: center;
  gap: 8px;
}

.profile-email span {
  overflow-wrap: anywhere;
  word-break: break-word;
}

.profile-detail {
  display: flex;
  align-items: flex-start;
  gap: 8px;
}

.profile-role,
.profile-detail {
  font-style: italic;
  color: var(--kate-type-primary);
}

.profile-detail-label {
  font-family: hk-grotesk-semibold, sans-serif;
  font-style: normal;
}

.signed-success {
  color: var(--kate-type-success);
}

.signed-pending {
  color: var(--kate-type-danger);
}
</style>

<script>
import TextFormattingMixin from '@mixins/text-formatting-mixins';
import { formatId } from '@utils/format-user-id';
import KAvatar from './k-avatar.vue';

export default {
  components: { KAvatar },
  mixins: [TextFormattingMixin],

  props: {
    name: {
      type: String,
    },
    email: {
      type: String,
    },
    avatarUrl: {
      type: String,
    },
    role: {
      type: String,
    },
    userId: {
      type: [String, Number],
    },
    details: {
      type: Array,
      default: () => [],
    },
  },

  computed: {
    formattedUserId() {
      return formatId(this.userId);
    },

    formattedUserRole() {
      return this.formatUserRole(this.formattedUserId, this.startCase(this.role));
    },
  },

  methods: {
    formatUserRole(id, type) {
      if (id && type) {
        return `${id} | ${type}`;
      }
      if (id) {
        return id;
      }
      if (type) {
        return type;
      }
      return '';
    },
  },
};
</script>
